import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

import { legacySiteId, type LegacySiteId } from './LegacySite.js'
import { projectId, type ProjectId } from './Project.js'
import { userId, type UserId } from './User.js'

/** Identifier type for public.user_recent_ */
export type UserRecentId = number & { __brand: 'UserRecentId' }

/** Represents the table public.user_recent_ */
export default interface UserRecentTable {
  /** Database type: pg_catalog.int4 */
  id: ColumnType<UserRecentId, UserRecentId | undefined, UserRecentId>

  /** Database type: pg_catalog.uuid */
  userId: ColumnType<UserId, UserId, UserId>

  /** Database type: pg_catalog.int4 */
  siteId: ColumnType<
    LegacySiteId | null,
    LegacySiteId | null,
    LegacySiteId | null
  >

  /** Database type: pg_catalog.int4 */
  projectId: ColumnType<ProjectId | null, ProjectId | null, ProjectId | null>

  /** Database type: pg_catalog.timestamptz */
  viewedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.int4 */
  viewCount: ColumnType<number, number | undefined, number>
}

export type UserRecent = Selectable<UserRecentTable>

export type UserRecentInitializer = Insertable<UserRecentTable>

export type UserRecentMutator = Updateable<UserRecentTable>

export const userRecentId = z.number() as unknown as z.Schema<UserRecentId>

export const userRecent = z.object({
  id: userRecentId,
  userId: userId,
  siteId: legacySiteId.nullable().optional(),
  projectId: projectId.nullable().optional(),
  viewedAt: z.coerce.date().nullable().optional(),
  viewCount: z.number(),
}) as unknown as z.Schema<UserRecent>

export const userRecentInitializer = z.object({
  id: userRecentId.optional(),
  userId: userId,
  siteId: legacySiteId.optional().nullable(),
  projectId: projectId.optional().nullable(),
  viewedAt: z.coerce.date().optional().nullable(),
  viewCount: z.number().optional(),
}) as unknown as z.Schema<UserRecentInitializer>

export const userRecentMutator = z.object({
  id: userRecentId.optional(),
  userId: userId.optional(),
  siteId: legacySiteId.optional().nullable(),
  projectId: projectId.optional().nullable(),
  viewedAt: z.coerce.date().optional().nullable(),
  viewCount: z.number().optional(),
}) as unknown as z.Schema<UserRecentMutator>
